"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m2.3979 2.414 19.1846 19.1906-1.3978 1.3965-4.1861-4.1873A7.9488 7.9488 0 0 1 13 19.8214V22h-2v-2.1786c-3.9463-.4921-7-3.8585-7-7.9381v-.8828c.5253-.0657 1.0503-.1449 1.5798-.1676a7.9579 7.9579 0 0 1-1.5412-3.9828L1 3.8105 2.3979 2.414zm10.7258 13.524 1.3931 1.3935A5.9582 5.9582 0 0 1 13 17.8003c0-.6244-.0144-1.2488.1237-1.8623zm-2.7329-1.1963c-.9042-1.4206-2.7416-1.9004-4.3174-1.9173.4002 2.5404 2.3945 4.5511 4.9266 4.9759 0-1.0597-.0194-2.1318-.6092-3.0586z"
  }), _react.default.createElement("path", {
    d: "m8.0273 5.2163 5.0622 5.0638c.1034-.554.2892-1.0002.5197-1.3625.3609-.567.8682-.9855 1.4666-1.2877.8906-.4497 1.943-.6199 2.8508-.6296-.3167 2.0104-1.6813 3.7621-3.5482 4.569l1.5477 1.5482c.668-.202 1.3693-.2863 2.0005-.2931a5.955 5.955 0 0 1-.5564 1.7377l1.4706 1.4711C19.5764 14.8232 20 13.4027 20 11.8833v-.8828c-.5253-.0657-1.0504-.1449-1.5798-.1676C19.4126 9.5004 20 7.8484 20 6.0591V3h-2v2.0001c-1.5522.0015-3.5104.3606-5 1.6148V2h-2v4.615c-.8868-.7468-1.9377-1.1715-2.9727-1.3987z"
  })];
};

exports.default = _default;